<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('review_with_draw_request')" :is-filter="false"/>
            </template>
            <template v-slot:header-mobile>
                <Header-mobile :title="$t('review_with_draw_request')" :is-filter="false"/>
            </template>
            <div>
                <b-row class="mx-1">
                    <b-col md="5" class="border rounded p-4 mb-3">
                        <h6 class="mt-1 mb-3">{{ this.$t('university_informations') }}</h6>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group :label="$t('student_number')">
                                    {{ student.student_number }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('faculty')">
                                    {{ student.faculty_name }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('program')">
                                    {{ student.program_name }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('class')">
                                    {{ student.class }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('legal_presence_type')">
                                    {{ student.legal_presence_type }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('registration_type')">
                                    {{ student.registration_type }}
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col md="6" offset-md="1" class="border rounded p-4 mb-3">
                        <h6 class="mt-1 mb-3">{{ $t('personal_info') }}</h6>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group :label="$t('name')">
                                    {{ getObjectValue(student, 'name') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('surname')">
                                    {{ getObjectValue(student, 'surname') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('gsm_no')">
                                    {{ getObjectValue(student, 'mobile_tel') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('email')">
                                    {{ getObjectValue(student, 'email') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('student_reason')">
                                    <div class="text-break">
                                        {{ getObjectValue(student, 'reason') }}
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$t('final_reason')">
                                    <div class="text-break">
                                        {{ getObjectValue(student, 'instructor_reason') }}
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <h6 class="mt-1 mb-3">{{ $t('personal_info') }}</h6>
                <div class="border rounded p-4 mb-3">
                    <datatable
                        :rows="datatable.rows"
                        :columns="datatable.columns"
                        :query-params="datatable.queryParams"
                        v-show="datatable.showTable"
                        :is-loading="datatable.isLoading"
                    >
                    </datatable>
                </div>
            </div>
            <CommonModal
                ref="updateFormModal"
                size="lg"
                :onHideOnlyX="true"
            >
                <template v-slot:CommonModalTitle>
                    {{ $t("approve").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <p>{{ $t('are_you_sure_you_want_to_update_the_with_draw_request_status') }}</p>
                    <ValidationObserver ref="formModalValidate">
                        <b-row>
                            <b-col>
                                <ValidationProvider name="reason" rules="required" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('reason')">
                                        <b-form-textarea no-resize rows="4" class="h-80 h-auto-sm" maxlength="500"
                                                            v-model="reason"></b-form-textarea>
                                        <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                   </ValidationObserver>
                   <div class="d-flex justify-content-end mt-4">
                        <b-button
                            variant="success"
                            class="mr-2"
                            @click="confirmUpdateStatus('accepted')"
                        >
                            {{ $t('approve') }}
                        </b-button>
                        <b-button
                            variant="danger"
                            @click="confirmUpdateStatus('denied')"
                        >
                            {{ $t('reject') }}
                        </b-button>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

import Datatable from "@/components/datatable/Datatable";

import WithDrawService from "@/services/WithDrawService";

export default {
    components: {
        Datatable, HeaderMobile, Header, AppLayout
    },
    data() {
        return {
            trainee: {},
            student: {},
            datatable: {
                columns: [
                    {
                        label: "",
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('approve_or_reject'),
                                class: 'ri-check-line align-middle top-minus-1 mr-3 text-success',
                                permission: 'withdraw_approveinstructorwithdraw',
                                callback: () => {
                                    this.updateStatus(this.$route.params.id)
                                },
                            }

                        ]
                    },
                    {field: "semester", label: this.toUpperCase("semester"), hidden: false, sortable: false},
                    {field: this.getLocaleField("slot_type_name"), label: this.toUpperCase("slot_type"), hidden: false, sortable: false},
                    {field: "course_code", label: this.toUpperCase("course_code"), hidden: false, sortable: false},
                    {field: "course_name", label: this.toUpperCase("course_name"), hidden: false, sortable: false},
                    {field: "reason", label: this.toUpperCase("reason"), hidden: false, sortable: false, tdClass: 'text-break'},
                    {field: "credit", label: this.toUpperCase("credit"), hidden: false, sortable: false},
                    {
                        label: this.$t('status').toUpper(),
                        field: 'status',
                        sortable: false,
                        hidden: false,
                        formatFn: (value) => {
                            if (value == 'waiting') return this.$t('waiting');
                            else if (value == 'denied') return this.$t('denied');
                            else if (value == 'accepted') return this.$t('accepted');

                            return '-';
                        }
                    }
                ],
                showTable: false,
                isLoading: false,
                rows: [],
                queryParams: {},
            },
            reason: null

        }
    },
    created() {
        this.getRows()
    },
    methods: {
        getRows() {

            this.datatable.isLoading = true;
            this.datatable.showTable = true;


            WithDrawService.show(this.$route.params.id)
                .then((res) => {
                        this.student = res.data.data
                        this.datatable.rows = [{
                            ...this.student.student_course,
                            semester: this.student.student_course.semester.semester,
                            reason: this.student.reason,
                            status: this.student.status
                        }]
                    }
                ).catch(e => this.showErrors(e))
                .finally(() => this.datatable.isLoading = false)
        },
        updateStatus(id) {
            // this.$swal
            //     .fire({
            //         text: this.$t('are_you_sure_you_want_to_update_the_with_draw_request_status'),
            //         showCancelButton: true,
            //         confirmButtonText: this.$t("approve"),
            //         cancelButtonText: this.$t("reject"),
            //         customClass: {
            //             confirmButton: 'btn btn-success mr-2',
            //             cancelButton: 'btn btn-danger'
            //         },
            //         buttonsStyling: false
            //     })
            //     .then((result) => {
            //         if (result.isConfirmed) {
            //             WithDrawService.updateStatus(id, {
            //                 status: "accepted",
            //             })
            //                 .then((response) => {
            //                     this.$toast.success(this.$t("api." + response.data.message));
            //                     this.$refs.datatable.getRows()
            //                 })
            //                 .catch((error) => {
            //                     this.showErrors(error);
            //                 });
            //         } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            //             WithDrawService.updateStatus(id, {
            //                 status: "denied",
            //             })
            //                 .then((response) => {
            //                     this.$toast.success(this.$t("api." + response.data.message));
            //                     this.$refs.datatable.getRows()
            //                 })
            //                 .catch((error) => {
            //                     this.showErrors(error);
            //                 });
            //         }
            //     })

            this.$refs.updateFormModal.$refs.commonModal.show();

        },
        async confirmUpdateStatus(status) {
            const isValid = await this.$refs.formModalValidate.validate();
            if(isValid) {
                WithDrawService.updateStatus(this.$route.params.id, { status: status, instructor_reason: this.reason })
                    .then((response) => {
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$refs.updateFormModal.$refs.commonModal.hide();
                        this.getRows();
                    })
                    .catch((error) => {
                        this.showErrors(error);
                    });
            }
        }

    },
}
</script>
<style scoped>
.text-break {
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
}
</style>
